/**
 * This is not an exhaustive list of all the plan codes.
 * It is not intended to be used as a Type definition for PlanCodes.
 */
export const PlanCodes = {
    STARTER_MONTHLY: '4000',
    STARTER_ANNUAL: '4010',
    ULAA_MONTHLY: '4100',
    ULAA_ANNUAL: '4110',
    PRO_MONTHLY: '4200',
    PRO_ANNUAL: '4210',
    SMALL_BUSINESS_ANNUAL: '8008',
    ESSENTIALS_ANNUAL: '4015',
    ESSENTIALS_MONTHLY: '4030',
    ESSENTIALS_10X_ANNUAL: '4016',
    ESSENTIALS_10X_MONTHLY: '4031',
    ALL_ACCESS_ANNUAL: '4115',
    ALL_ACCESS_MONTHLY: '4130',
    ALL_ACCESS_10X_ANNUAL: '4116',
    ALL_ACCESS_10X_MONTHLY: '4131',
    BUSINESS_ANNUAL: '4215',
    SMALL_BUSINESS_10X_ANNUAL: '4216',
};

const companionPlansMap = {
    '4000': PlanCodes.STARTER_ANNUAL,
    '4010': PlanCodes.STARTER_MONTHLY,
    '4100': PlanCodes.ULAA_ANNUAL,
    '4110': PlanCodes.ULAA_MONTHLY,
    '4200': PlanCodes.PRO_ANNUAL,
    '4210': PlanCodes.PRO_MONTHLY,
    '4015': PlanCodes.ESSENTIALS_MONTHLY,
    '4030': PlanCodes.ESSENTIALS_ANNUAL,
    '4016': PlanCodes.ESSENTIALS_10X_MONTHLY,
    '4031': PlanCodes.ESSENTIALS_10X_ANNUAL,
    '4115': PlanCodes.ALL_ACCESS_MONTHLY,
    '4130': PlanCodes.ALL_ACCESS_ANNUAL,
    '4116': PlanCodes.ALL_ACCESS_10X_MONTHLY,
    '4131': PlanCodes.ALL_ACCESS_10X_ANNUAL,
    // Note: BUSINESS_ANNUAL (4215) and SMALL_BUSINESS_10X_ANNUAL (4216) have no monthly companion
};

export const getCompanionPlanCode = (planCode: string): string => {
    return companionPlansMap[planCode as keyof typeof companionPlansMap] ?? '';
};
